<template>
  <div>
    <el-dialog
        class="linkLetter"
        title="离线请留言"
        :visible.sync="letterVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
        width="100%">
      <div>
        <el-alert
            title="由于客服没有在线，不能提供在线服务，有问题可以给我们留言！!"
            type="info"
            :closable="false">
        </el-alert>

        <div class="weblinkLetter">
          <el-form label-position="top" label-width="80px" :model="data">
            <el-form-item label="电话">
              <el-input v-model="data.phone"></el-input>
            </el-form-item>
            <el-form-item label="留言内容">
              <el-input
                  type="textarea"
                  rows="4"
                  placeholder="请输入内容"
                  v-model="data.content">
              </el-input>
            </el-form-item>
          </el-form>
          <el-button @click="postLetter" style="width: 100%;margin-top: 6px" type="primary">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
name: "moveLetter",
  data() {
    return {
      teamID: '',
      YQToken: '',
      letterVisible: true,
      beforeUrl: '',
      data: {
        'phone': '',
        'content':''
      }
    }
  },

  mounted() {
    this.teamID = this.$route.query.teamID
    this.YQToken = this.$route.query.YQToken
    this.beforeUrl = this.$route.query.beforeUrl
  },

  methods:{
    //获取账号信息
    postLetter()
    {
      this.data.teamID = this.teamID
      this.data.YQToken = this.YQToken
      this.$https({url: 'LeavingMsg',data:this.data,method: "post"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.data = {}
          this.$notify({
            message: '留言保存成功！',
            type: 'success'
          });
        }
        if (backData.data.status === 201)
        {
          this.data = {}
          this.$notify({
            message: '留言参数不能为空！',
            type: 'warning'
          });
        }
      });
    },
    handleClose(done) {
      if (this.beforeUrl)
      {
        window.location.replace(this.beforeUrl)
      }
    }
  },
}
</script>

<style>
.linkLetter .el-dialog__body{
  padding: 0;
}
.weblinkLetter{
  padding: 10px 20px 30px 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/link/moveLetter.vue